import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './text-field.scss';

class TextField extends PureComponent {
  render() {
    const { id, label, error, content, ...props } = this.props;

    return (
      <div className="field-container">
        <label className={cn({ error })} htmlFor={id}>
          {label}

          {(!!error) &&
            <span className="error-msg">{error}</span>
          }
        </label>

        <input id={id} formNoValidate { ...props } />

        {content}
      </div>
    );
  }
}

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  content: PropTypes.node
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/widgets/TextField/index.js